import DashboardClientLayout from "src/pages/Dashboard/Layout/DashboardLayoutClient.vue";
import DashboarIndex from "src/pages/Dashboard/index.vue";
import AuthLayout from "src/pages/Dashboard/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";

// Page Headers
import CalendarHeader from "src/pages/Dashboard/Calendar/CalendarHeader";
const DashboardHeader = () =>
    import(
        /* webpackChunkName: "dashboard" */
        "src/pages/Dashboard/Dashboard/DashboardHeader.vue"
    );
import DefaultHeader from "src/pages/Dashboard/DefaultHeader";
import SweetAlertHeader from "src/pages/Dashboard/Components/Headers/SweetAlertHeader";
import VectorMapsHeader from "src/pages/Dashboard/Maps/VectorMapsHeader";

// Calendar
const Calendar = () =>
    import(
        /* webpackChunkName: "calendar" */
        "src/pages/Dashboard/Calendar/CalendarRoute.vue"
    );
// Charts
const Charts = () =>
    import( /* webpackChunkName: "charts" */ "src/pages/Dashboard/Charts.vue");

// Components pages
const Buttons = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/Buttons.vue"
    );
const GridSystem = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/GridSystem.vue"
    );
const Panels = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/Panels.vue"
    );
const SweetAlert = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/SweetAlert.vue"
    );
const Notifications = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/Notifications.vue"
    );
const Icons = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/Icons.vue"
    );
const Typography = () =>
    import(
        /* webpackChunkName: "components" */
        "src/pages/Dashboard/Components/Typography.vue"
    );

// Dashboard pages
const Dashboard = () =>
    import(
        /* webpackChunkName: "dashboard" */
        "src/pages/views/dashboard/DashboardMain.vue"
    );
import Widgets from "src/pages/Dashboard/Widgets.vue";

// Forms pages
const RegularForms = () =>
    import("src/pages/Dashboard/Forms/RegularForms.vue");
const ExtendedForms = () =>
    import("src/pages/Dashboard/Forms/ExtendedForms.vue");
const ValidationForms = () =>
    import("src/pages/Dashboard/Forms/ValidationForms.vue");
const Wizard = () =>
    import("src/pages/Dashboard/Forms/Wizard.vue");

// Maps pages
const GoogleMaps = () =>
    import(
        /* webpackChunkName: "maps" */
        "src/pages/Dashboard/Maps/GoogleMaps.vue"
    );
const FullScreenMap = () =>
    import(
        /* webpackChunkName: "maps" */
        "src/pages/Dashboard/Maps/FullScreenMap.vue"
    );
const VectorMaps = () =>
    import(
        /* webpackChunkName: "maps" */
        "src/pages/Dashboard/Maps/VectorMaps.vue"
    );

// Pages
const User = () =>
    import(
        /* webpackChunkName: "pages" */
        "src/pages/Dashboard/Pages/UserProfile.vue"
    );
const Pricing = () =>
    import(
        /* webpackChunkName: "pages" */
        "src/pages/Dashboard/Pages/Pricing.vue"
    );
const TimeLine = () =>
    import(
        /* webpackChunkName: "pages" */
        "src/pages/Dashboard/Pages/TimeLinePage.vue"
    );
const Login = () =>
    import( /* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Login.vue");
const Register = () =>
    import(
        /* webpackChunkName: "auth" */
        "src/pages/Dashboard/Pages/Register.vue"
    );
const CambiarContrasena = () =>
    import(
        /* webpackChunkName: "auth" */
        "src/pages/Dashboard/Pages/ChangePassword.vue"
    );

const Registro = () =>
    import(
        /* webpackChunkName: "auth" */
        "src/pages/Dashboard/Pages/Registro.vue"
    );
const Lock = () =>
    import( /* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Lock.vue");

/* = = = ELEMENTOS PÁGINA = = = */
const VistaHome = () =>
    import("src/pages/views/Home.vue");

const VistaPerfiles = () =>
    import("src/pages/views/perfiles/perfiles.vue");

const VistaProspectos = () =>
    import("src/pages/views/prospectos/prospectos.vue");

const VistaLogout = () =>
    import("src/pages/Dashboard/Pages/Logout.vue");

const VistaComunicados = () =>
    import("src/pages/views/comunicados/comunicados.vue");

const VistaUsuarios = () =>
    import("src/pages/views/usuarios/usuario.vue");

const VistaUnidadMedida = () =>
    import("src/pages/views/catalogos/unidadMedida/unidadMedida.vue");

const VistaMonedas = () =>
    import("src/pages/views/monedas/monedas.vue");

//
const VistaNotificaciones = () =>
    import("src/pages/views/notificaciones/notificaciones.vue");

const VistaCategoriaProducto = () =>
    import("src/pages/views/categoriaproducto/categoriaproducto.vue");

const VistaSubcategoriaProducto = () =>
    import("src/pages/views/subcategoriaproducto/subcategoriaproducto.vue");

const VistaReclamaciones = () =>
    import("src/pages/views/reclamaciones/reclamaciones.vue");
const VistaPedidos = () =>
    import("src/pages/views/pedidos/pedidos.vue");

const VistaNuevoPedido = () =>
    import("src/pages/views/pedidos/pedidosAdd.vue");

const VistaMailConfig = () =>
    import("src/pages/views/mailconfiguration/mailconfiguration.vue");
const VistaProductos = () =>
    import("src/pages/views/productos/ProductosMain.vue");

const VistaClientes = () =>
    import("src/pages/views/clientes/clientes.vue");

const VistaTiposDocumentos = () =>
    import("src/pages/views/tiposDocumentos/tiposDocumentos.vue");

const VistaCaracteristicaProducto = () =>
    import("src/pages/views/productocaracteristica/productocaracteristica.vue");

const VistaMotivosDeclinacion = () =>
    import("src/pages/views/motivoDeclinacion/motivoDeclinacion.vue");

const VistaConfiguracionNotificaciones = () =>
    import(
        "src/pages/views/configuracionNotificaciones/configuracionNotificaciones.vue"
    );
const VistaHorarioIngreso = () =>
    import("src/pages/views/horarioIngreso/horarioIngreso.vue");

const VistaFamiliaProducto = () =>
    import("src/pages/views/familiaproducto/familiaproducto.vue");

const VistaNuevaFamiliaProducto = () =>
    import("src/pages/views/familiaproducto/familiaProductoAddEdit.vue");

const VistaPropiedadFamiliaProducto = () =>
    import(
        "src/pages/views/propiedadFamiliaProducto/propiedadFamiliaProducto.vue"
    );

const VistaPerfilesEmpresariales = () =>
    import("src/pages/views/perfilesEmpresariales/perfilEmpresarial.vue");

const VistaNuevoPerfilEmpresarial = () =>
    import("src/pages/views/perfilesEmpresariales/perfilEmpresarialAdd.vue");

const VistaEditarPerfilEmpresarial = () =>
    import("src/pages/views/perfilesEmpresariales/perfilEmpresarialEdit.vue");

const VistaNuevoRol = () =>
    import("src/pages/views/perfiles/perfilesAdd.vue");

const VistaRol = () =>
    import("src/pages/views/perfiles/perfilesAdd.vue");

const VistaEditarPerfil = () =>
    import("src/pages/views/perfiles/perfilesEdit.vue");

const VistaNotificacionesWeb = () =>
    import("src/pages/views/notificacionesWeb/notificacionesWeb.vue");

const VistaPedidosDetalles = () =>
    import("src/pages/views/pedidos/pedidosDetails.vue");

const VistaPedidosDocumentos = () =>
    import("src/pages/views/pedidos/pedidosDocs.vue");

const VistaFacturas = () =>
    import("src/pages/views/clientes/facturas.vue");

const VistaPedidosPartidas = () =>
    import("src/pages/views/pedidos/pedidosPartidas.vue");

const VistaTrackingPedido = () =>
    import("src/pages/views/pedidos/trackingPedido.vue");

const VistaEstadoCuentaCliente = () =>
    import("src/pages/views/clientes/estadoCuentaCliente.vue");

const VistaCatalogoProductos = () =>
    import("src/pages/views/catalogoProductos/catalogoProductos.vue");

const VistaDetallePedido = () =>
    import("src/pages/views/web/pages/pedidoDetalle.vue");

const VistaDetalleFamiliaProductos = () =>
    import("src/pages/views/catalogoDetalleFamiliaProducto/detalleFamiliaProducto.vue");

const VistaNuevoReclamaciones = () =>
    import("src/pages/views/reclamaciones/reclamacionesAdd.vue");


const VistaTrackingPartida = () =>
    import("src/pages/views/web/pages/partidaTracking.vue");

const VistaConfiguracion = () =>
    import("src/pages/views/web/pages/config.vue");

const VistaCarrito = () =>
    import("src/pages/views/web/pages/CartPedidoPage.vue")

const VistaMisPedidos = () =>
    import("src/pages/views/web/pages/misPedidos.vue");

const VistaMisFacturas = () =>
    import("src/pages/views/web/pages/misFacturas.vue");

const VistaMisEstadosCuenta = () =>
    import("src/pages/views/web/pages/misEstadosCuenta.vue");

const VistaHistorialCompra = () =>
    import("src/pages/views/web/pages/historialCompras.vue");

const VistaPedidosModelo = () =>
    import("src/pages/views/web/pages/pedidosModelo/pedidosModelo.vue");

const VistaComprasRapidas = () =>
    import("src/pages/views/web/pages/comprasRapidas.vue");

const VistaCambioInformacionCliente = () =>
    import("src/pages/views/cambioInformacionCliente/cambioInformacionCliente.vue")

const BackOrderReport = () => import("src/pages/views/reportes/BackOrderReport.vue")

const OpenInvoiceReport = () => import("src/pages/views/reportes/OpenInvoiceReport.vue")

const VistaAddByPartNumber = () => import("src/pages/views/web/pages/CartAddByPartNumber.vue")

const VistaAddOrderByExcel = () => import("src/pages/views/web/pages/addOrderByExcelUploadPage.vue")

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [{
        path: "/login",
        name: "Login",
        component: Login
    },
    {
        path: "/register",
        name: "Register",
        component: Login
    },
        /*{
          path: "/register",
          name: "Register",
          component: Register
        },
        {
            path: "/registro",
            name: "Registro",
            component: Registro
        },
        {
          path: "/pricing",
          name: "Pricing",
          component: Pricing
        },
        {
          path: "/lock",
          name: "Lock",
          component: Lock
        },*/
        /*{
          path: "/logout",
          name: "Logout",
          component: VistaLogout
        }*/
    ]
};
let changePass = {
    path: "/cambiar_contrasena/:token",
    component: CambiarContrasena,
    name: "Cambiar Contraseña",
    meta: { require_auth: false }
}
let logout = {
    path: "/logout",
    component: VistaLogout,
    name: "Logout",
}

let viewPages = {
    path: "/admin",
    component: DashboarIndex,
    name: "Views",
    children: [{
        path: "roles",
        name: "Roles",
        components: { default: VistaPerfiles, header: DefaultHeader }
    },
    {
        path: "roles_empresariales",
        name: "Roles empresariales",
        components: { default: VistaPerfilesEmpresariales, header: DefaultHeader }
    },
    {
        path: "roles_empresariales_nuevo",
        name: "Nuevo rol empresarial",
        components: {
            default: VistaNuevoPerfilEmpresarial,
            header: DefaultHeader
        }
    },
    {
        path: "roles_empresariales_editar",
        name: "Editar rol empresarial",
        components: {
            default: VistaEditarPerfilEmpresarial,
            header: DefaultHeader
        }
    },
    {
        path: "prospectos",
        name: "Prospectos",
        components: { default: VistaProspectos, header: DefaultHeader }
    },
    {
        path: "comunicados",
        name: "Comunicados",
        components: { default: VistaComunicados, header: DefaultHeader }
    },
    {
        path: "usuarios",
        name: "Usuarios",
        components: { default: VistaUsuarios, header: DefaultHeader }
    },
    {
        path: "medidas",
        name: "Medidas",
        components: { default: VistaUnidadMedida, header: DefaultHeader }
    },
    {
        path: "monedas",
        name: "Monedas",
        components: { default: VistaMonedas, header: DefaultHeader }
    },
    {
        path: "notificaciones",
        name: "Notificaciones",
        components: { default: VistaNotificaciones, header: DefaultHeader }
    },
    {
        path: "categorias",
        name: "Categorias",
        components: { default: VistaCategoriaProducto, header: DefaultHeader }
    },
    {
        path: "subcategorias",
        name: "Sub categorias",
        components: { default: VistaSubcategoriaProducto, header: DefaultHeader }
    },
    {
        path: "pedidos",
        name: "Pedidos",
        components: { default: VistaPedidos, header: DefaultHeader }
    },
    {
        path: "nuevo_pedido",
        name: "Nuevo Pedido",
        components: { default: VistaNuevoPedido, header: DefaultHeader }
    },
    {
        path: "configuracion_email",
        name: "Configuración email",
        components: { default: VistaMailConfig, header: DefaultHeader }
    },
    {
        path: "productos",
        name: "Productos",
        components: { default: VistaProductos, header: DefaultHeader }
    },
    {
        path: "clientes",
        name: "Clientes",
        components: { default: VistaClientes, header: DefaultHeader }
    },
    {
        path: "caracteristicas_producto",
        name: "Caracteristicas Producto",
        components: {
            default: VistaCaracteristicaProducto,
            header: DefaultHeader
        }
    },
    {
        path: "tipos_documentos",
        name: "Tipos documentos",
        components: { default: VistaTiposDocumentos, header: DefaultHeader }
    },
    {
        path: "motivos_declinacion",
        name: "Motivos declinacion",
        components: { default: VistaMotivosDeclinacion, header: DefaultHeader }
    },
    {
        path: "configuracion_notificaciones",
        name: "Configuracion notificaciones",
        components: {
            default: VistaConfiguracionNotificaciones,
            header: DefaultHeader
        }
    },
    {
        path: "horario_ingreso",
        name: "Horario ingreso",
        components: {
            default: VistaHorarioIngreso,
            header: DefaultHeader
        }
    },
    {
        path: "familia_producto",
        name: "Familias productos",
        components: { default: VistaFamiliaProducto, header: DefaultHeader }
    },
    {
        path: "nueva_familia_producto/:id?",
        name: "Nueva Familia de Productos",
        components: { default: VistaNuevaFamiliaProducto, header: DefaultHeader }
    },
    {
        path: "propiedades_familias_producto",
        name: "Propiedades de familias de productos",
        components: {
            default: VistaPropiedadFamiliaProducto,
            header: DefaultHeader
        }
    },
    {
        path: "nuevo_rol",
        name: "Nuevo Rol",
        components: { default: VistaNuevoRol, header: DefaultHeader }
    },
    {
        path: "roles",
        name: "Roles",
        components: { default: VistaRol, header: DefaultHeader }
    },
    {
        path: "roles_editar",
        name: "Editar rol",
        components: { default: VistaEditarPerfil, header: DefaultHeader }
    },
    {
        path: "notificaciones_web",
        name: "Notificaciones web",
        components: { default: VistaNotificacionesWeb, header: DefaultHeader }
    },
    {
        path: "pedidos/:idPedido/detalle",
        name: "Detalle pedido",
        components: { default: VistaPedidosDetalles, header: DefaultHeader }
    },
    /*{
      path: "pedidos/:idPedido/documentos",
      name: "Documentos pedido",
      components: { default: VistaPedidosDocumentos, header: DefaultHeader }
    },*/
    {
        path: "facturas_cliente",
        name: "Facturas cliente",
        components: { default: VistaFacturas, header: DefaultHeader }
    },
    {
        path: "pedidos/:idPedido/partidas",
        name: "Partidas pedido",
        components: { default: VistaPedidosPartidas, header: DefaultHeader }
    },
    {
        path: "pedidos/:idPedido/tracking_pedido",
        name: "Tracking pedido",
        components: { default: VistaTrackingPedido, header: DefaultHeader }
    },
    {
        path: "estado_cuenta_cliente",
        name: "Estado cuenta cliente",
        components: { default: VistaEstadoCuentaCliente, header: DefaultHeader }
    },
    ]
};


const routes = [{
    path: "/",
    redirect: "/principal",
    name: "Home"
},
    viewPages,
    authPages,
    changePass,
    logout,
{
    path: "/",
    component: DashboardClientLayout,
    redirect: "/principal",
    name: "Principal",
    children: [{
        path: "principal",
        name: "Principal",
        components: { default: VistaHome, header: DefaultHeader }
    },
    {
        path: "catalogo_productos",
        name: "Catalogo Productos",
        components: { default: VistaCatalogoProductos, header: DefaultHeader },
        meta: {
            controller: "FamiliasProducto",
            action: "getFamiliaProductoByCategoria"
        }
    },
    {
        path: "pedidos/:idPedido/detalle",
        name: "Detalle pedido web",
        components: { default: VistaDetallePedido, header: DefaultHeader }
    },
    {
        path: "detalle_familia_producto/:idFamilia",
        name: "Detalle Familia Producto",
        components: { default: VistaDetalleFamiliaProductos, header: DefaultHeader }
    },
    {
        path: "reclamaciones",
        name: "Reclamaciones",
        components: { default: VistaReclamaciones, header: DefaultHeader },
        meta: {
            controller: "Reclamaciones",
            action: "getReclamacionesByCliente"
        }

    },
    {
        path: "reclamaciones/nueva_reclamacion",
        name: "Nueva Reclamacion",
        components: { default: VistaNuevoReclamaciones, header: DefaultHeader }
    },
    {
        path: "tracking_partida_tracking",
        name: "Tracking partida web",
        components: { default: VistaTrackingPartida, header: DefaultHeader }
    },
    {
        path: "config_web",
        name: "Configurar web",
        components: { default: VistaConfiguracion, header: DefaultHeader }
    },
    {
        path: "cart_pedido_page",
        name: "Solicitar Pedido",
        components: { default: VistaCarrito, header: DefaultHeader }
    },
    {
        path: "mis_pedidos",
        name: "Mis Pedidos",
        components: { default: VistaMisPedidos, header: DefaultHeader },
        meta: {
            controller: "Pedidos",
            action: "listaPedidosWebWithProductoCliente"
        }
    },
    {
        path: "mis_facturas",
        name: "Mis Facturas",
        components: { default: VistaMisFacturas, header: DefaultHeader }
    },
    {
        path: "mis_estados_cuenta",
        name: "Mis Estados Cuenta",
        components: { default: VistaMisEstadosCuenta, header: DefaultHeader }
    },
    {
        path: "compras_recientes",
        name: "Compras recientes",
        components: { default: VistaHistorialCompra, header: DefaultHeader },
        meta: {
            controller: "Pedidos",
            action: "getUltimosProductosAdquiridosWeb"
        }
    },
    {
        path: "pedidos_modelo",
        name: "Pedidos Modelo",
        components: { default: VistaPedidosModelo, header: DefaultHeader },
        meta: {
            controller: "Pedidos",
            action: "pedidosModeloByUser"
        }
    }

        /*{
          path: "dashboard",
          name: "Dashboard",
          components: { default: Dashboard, header: DefaultHeader }
        },
        {
          path: "calendar",
          name: "Calendar",
          components: { default: Calendar, header: CalendarHeader }
        },
        {
          path: "charts",
          name: "Charts",
          components: { default: Charts, header: DefaultHeader }
        },
        {
          path: "widgets",
          name: "Widgets",
          components: { default: Widgets, header: DefaultHeader }
        }*/
        ,
    {
        path: "compra_rapida/:token",
        name: "Compra rapida",
        components: { default: VistaComprasRapidas, header: DefaultHeader },
        meta: {
            controller: "CompraRapida",
            action: "getProductosByToken"
        }
    },
    {
        path: "cambio_informacion_cliente",
        name: "Cambio informacion cliente",
        components: { default: VistaCambioInformacionCliente, header: DefaultHeader },
        /*meta: {
          controller: "Pedidos",
          action: "pedidosModeloByUser"
        }*/
    },
    {
        path: 'reporte/back-order',
        name: "Reporte Back Order",
        components: {
            default: BackOrderReport,
            header: DefaultHeader
/*            controller: "Reportes",
            action: "getReporteBackOrder"*/
        }
    },
      {
        path: 'reporte/open-invoices',
        name: "Reporte Open Invoice",
        components: {
          default: OpenInvoiceReport,
          header: DefaultHeader
        }
      },
      {
        path: 'add-by-part-number',
        name: "Añadir por Numero de Parte",
        components: {
          default: VistaAddByPartNumber,
          header: DefaultHeader
        }
      },
      {
        path: 'add-by-excel',
        name: "Añadir por Numero de Parte",
        components: {
          default: VistaAddOrderByExcel,
          header: DefaultHeader
        }
      }
    ]
},
{ path: "*", component: NotFound }
];

export default routes;
